import React, { useRef, useEffect, useState } from "react";
import { Card, Spinner, Row, Col, Container } from "react-bootstrap";
import Chart from "chart.js/auto";
import { toast } from "react-toastify";

interface Props {
  dadosPedidos: any;
  loading: boolean;
  error: string | null;
}

const PedidosPorClienteChart: React.FC<Props> = ({ dadosPedidos, loading, error }) => {
  const chartRef = useRef<HTMLCanvasElement | null>(null);
  const [chartInstance, setChartInstance] = useState<Chart | null>(null);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (dadosPedidos?.vendas_x_cliente && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (!ctx) return;

      if (chartInstance) {
        chartInstance.destroy(); // Remove o gráfico anterior antes de criar um novo
      }

      const vendasPorCliente = dadosPedidos.vendas_x_cliente.map((cliente: any) =>
        parseFloat(cliente.TOTAL_PEDIDOS)
      );
      const nomesClientes = dadosPedidos.vendas_x_cliente.map((cliente: any) => cliente.NOME_FANTASIA);

      const newChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: nomesClientes,
          datasets: [
            {
              label: "Pedidos Totais",
              data: vendasPorCliente,
              backgroundColor: "rgba(75, 192, 192, 0.6)",
              borderColor: "rgba(75, 192, 192, 1)",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false, // Permite que o gráfico se ajuste melhor
          scales: {
            y: { beginAtZero: true },
          },
          plugins: {
            legend: {
              labels: {
                font: {
                  size: 14, // Ajuste para melhor leitura em telas menores
                },
              },
            },
          },
        },
      });

      setChartInstance(newChart);
    }
  }, [dadosPedidos]);

  return (
    <Card className="p-3 shadow" style={{minHeight: "300px"}}>
      <h5 className="text-center mb-3">Pedidos por Cliente</h5>
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p>Carregando dados...</p>
        </div>
      ) : (
        <div className="ratio ratio-16x9 w-100">
          <canvas ref={chartRef} />
        </div>
      )}
    </Card>
  );
};

export default PedidosPorClienteChart;
